import { useLocationName } from '@/hooks/useLocationName';
import { Skeleton } from '@/components/ui/skeleton';

interface LocationLabelProps {
  lat: number;
  lng: number;
  /** Fallback text while loading or if geocoding fails. */
  fallback?: string;
  className?: string;
}

/**
 * Displays a human-readable location name (e.g. "San Francisco, CA")
 * by reverse-geocoding the given coordinates.
 */
export function LocationLabel({ lat, lng, fallback, className }: LocationLabelProps) {
  const { data: locationName, isLoading } = useLocationName(lat, lng);

  if (isLoading) {
    return <Skeleton className="h-3.5 w-24 inline-block" />;
  }

  return (
    <span className={className}>
      {locationName || fallback || 'Unknown area'}
    </span>
  );
}
